import TrainingClass from './TrainingClass';

export default TrainingClass;
